/* import __COLOCATED_TEMPLATE__ from './start-time-import-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class StartTimeImportCardComponent extends Component 
{
	@service store;
	
	@tracked selectedEvent = null;
	@tracked earlyMargin = 60;
	@tracked importButtonDisabled = false;
	
	@action
	selectEvent(event)
	{
		this.selectedEvent = event;
	}
	
	@action
	importStartTimes()
	{
		this.importButtonDisabled = true;
		
		var that = this;
		if(this.selectedEvent == null)
		{
			this.importButtonDisabled = false;
			return;
		}
		
		this.selectedEvent.get('entries').then(function(entries)
		{
			that.args.translations.forEach(function(translation)
			{
				if(translation.bib != null)
				{
					var entryForTranslation = null;
					entries.forEach(function(entry)
					{
						if(entry.bib == translation.bib)
						{
							entryForTranslation = entry;
						}
					});
					if(entryForTranslation == null)
					{
						translation.startTime = dayjs();
						translation.save();
					}
					else
					{
						entryForTranslation.get('StartTimingRecordId').then(function(sTR)
						{
							var assignedStartTime = dayjs(sTR.assignedStartTime);
							translation.startTime = assignedStartTime.subtract(that.earlyMargin, 'seconds');
							translation.save();
						});
					}
				}
			});
			that.importButtonDisabled = false;
		});
	}
}